module.exports = require("dns");